exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CTA__ctaBG___1vTPN {\n  background-color: #ffab77;\n  margin: 120px 0px;\n  height: unset;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  align-items: left;\n  padding: 52px 1em 87px 1em;\n}\n@media (min-width: 768px) {\n  .CTA__ctaBG___1vTPN {\n    margin: 70px 0px;\n    padding: 49px 46px;\n  }\n}\n.CTA__ctaBG___1vTPN h1 {\n  text-align: left;\n  color: #000;\n  margin-top: 0;\n  margin-bottom: 70px;\n  font-weight: 700;\n  font-size: 60px;\n  line-height: 60px;\n  text-transform: lowercase;\n}\n.CTA__ctaBG___1vTPN h1 span {\n  color: #fff;\n}\n.CTA__buttonWrapper___38wgQ {\n  position: absolute;\n  bottom: 40px;\n  width: calc(100% - 2em);\n  left: unset;\n  align-self: auto;\n  max-width: 1248px;\n}\n.CTA__buttonWrapper___38wgQ button {\n  text-transform: lowercase;\n  font-weight: 400;\n}\n", ""]);

// exports
exports.locals = {
	"ctaBG": "CTA__ctaBG___1vTPN",
	"buttonWrapper": "CTA__buttonWrapper___38wgQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/static/CTA.styl
// module id = 238
// module chunks = 0